import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {FEATURE_SKILLS} from "../../../../core/gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../const";

export default class SkillsSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Skills",
            description              : "The User Skills module facilitates the management of skills for company users, allowing administrators to efficiently track and organize the skills possessed by employees within the organization.",
            svgIcon                  : "isvg-skills",
            settingsUrl              : "settings/user-skills",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : "Company users",
            feature                  : FEATURE_SKILLS
        });

        this.parentSection          = SettingsParentSection.COMPANY_USERS
    }

}
